// extracted by mini-css-extract-plugin
module.exports = {"drawer":"WellnessDrawer-module__drawer___O5Rn4","children":"WellnessDrawer-module__children___1q-p8","viewMapButton":"WellnessDrawer-module__viewMapButton___96mIE"};